<template>
    <div class="ListData">
        <div class="row m-4">
            <div class="col-lg-12 col-sm-12 ml-auto mr-auto">
                <div class="card ">
                    <div class="card-header">
                        <div class="row ml-1">
                            <h4 class="card-title">Company</h4>
                        </div>
                        <div class="row">
                            <div class="col-md-5 col-lg-5">
                                <div class="form-group">
                                    <label></label>
                                    <input type="text" class="form-control" name="search" id="search" placeholder="Search by Company Name" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div class="card-body">
                        <div class="col-lg-12">
                            <div class="row">
                                <div>
                                    <a href="javascript:void(0)" class="btn btn-outline-primary btn-round" v-on:click="AddCompany"><i class="fa fa-plus"></i> Add Company</a>
                                </div>
                            </div>
                            <div class="mt-2">
                                <div class=" table-responsive">
                                    <table class="table ">
                                        <thead class="m-0">
                                            <tr>
                                                <th>Id</th>
                                                <th>Name </th>
                                                <th>CompanyRegNo</th>
                                                <th>Website</th>
                                                <th>Phone No</th>
                                                <th>Landline</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(company,index) in companylist" v-bind:key="company.id">
                                                <td>
                                                    {{index+1}}
                                                </td>
                                                <td>
                                                    <strong>
                                                        <a href="javascript:void(0)" v-on:click="EditCompany(company.id)">{{company.nameEnglish}}</a>
                                                    </strong>
                                                </td>
                                                <td>{{company.vatRegistrationNo}}</td>
                                                <td>{{company.website}}</td>
                                                <td>{{company.phoneNo}}</td>
                                                <td>{{company.landLine}}</td>
                                                <td><a href="javascript:void(0)" class="btn btn-danger btn-sm btn-icon btn-round" v-on:click="RemoveCompany(company.id)"><i class=" fa fa-trash"></i></a></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'company',
        data: function () {
            return {
                companylist: [],
                searchQuery: '',
            }
        },
        computed: {
            resultQuery: function () {
                var root = this;
                if (this.searchQuery) {
                    return this.companylist.filter((companylist) => {
                        return root.searchQuery.toLowerCase().split(' ').every(v => companylist.name.toLowerCase().includes(v))
                    })
                } else {
                    return root.companylist;
                }
            },
        },
        methods: {
            GetCompanyData: function () {
                 //eslint-disable-line
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.$https.get('/Company/List', { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                         //eslint-disable-line
                        root.$store.state.companyList.push(response.data)
                        root.companylist = response.data;
                    }
                });
            },
            EditCompany: function (Id) {
                var root = this;
                var token = '';
                if (this.$session.exists()) {
                    token = localStorage.getItem('token');
                }
                this.$https.get('/Company/EditCompany?Id=' + Id, { headers: { "Authorization": `Bearer ${token}` } }).then(function (response) {
                    if (response.data != null) {
                         //eslint-disable-line
                        root.companylist = response.data
                    }
                    root.$router.push({
                        path: '/AddCompany',
                        query: {
                            data: root.companylist
                        }
                    })
                });
            },
            RemoveCompany: function (id) {
                var root = this;
                // working with IE and Chrome both
                this.$swal({
                    title: "Are you sure?",
                    text: "You will not be able to recover this!",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55",
                    confirmButtonText: "Yes, delete it!",
                    closeOnConfirm: false,
                    closeOnCancel: false
                }).then(function (result) {
                    if (result) {
                        var token = '';
                        if (this.$session.exists()) {
                            token = localStorage.getItem('token');
                        }
                        this.$https.post('/Company/Delete?Id=' + id, { headers: { "Authorization": `Bearer ${token}` } })
                            .then(function (response) {
                                if (response.data) {
                                    root.$store.state.companyList.splice(root.$store.state.companyList.findIndex(function (i) {
                                        return i.id === response.data;
                                    }), 1);
                                    root.$swal({
                                        title: 'Deleted!',
                                        text: 'Comapany has been Deleted.',
                                        type: 'success',
                                        confirmButtonClass: "btn btn-success",
                                        buttonsStyling: false
                                    });
                                } else {
                                    console.log("error: something wrong from db.");
                                }
                            },
                                function (error) {
                                    this.loading = false;
                                    console.log(error);
                                });
                    }
                    else {
                        this.$swal('Cancelled', 'Your file is still intact', 'info');
                    }
                });
            },
            AddCompany: function () {
                this.$router.push('/AddCompany')
            },
        },
        mounted: function () {
            this.GetCompanyData();
        }
    }
</script>